/**
 * Character image component for IA Corner displays.
 * Displays the main character image on top of the background with relative positioning.
 */

import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import Screen from '../../../../shared/utils/screen';

/**
 * Styled character image with relative positioning and rounded corners.
 */
const CharacterImage = styled.img<React.CSSProperties>`
  border-radius: ${16 * Screen.widthRatio}px;
  height: ${210 * Screen.widthRatio}px;
  bottom: ${10 * Screen.widthRatio}px;
  position: relative;
`;

export default withImage(CharacterImage, false);
